import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router'
import { useAuthUser } from 'contexts/AuthUserProvider'
import { homeURL, loginURL } from './urls'

const IsPracticeGroup: React.FC = ({ children }) => {
  const { authUser, logout } = useAuthUser()
  const location = useLocation()
  const params = useParams()

  const practiceGroupId = React.useMemo(() => Number(params.practiceGroupId), [params.practiceGroupId]) 

  if (authUser === undefined) {
    return null
  } else if (authUser === null) {
    return <Navigate replace to={loginURL(location.pathname)} />
  } else if (authUser.isStaff) {
    return <React.Fragment>{children}</React.Fragment>
  } else if (authUser.practiceGroupIds.includes(practiceGroupId)) {
    return <React.Fragment>{children}</React.Fragment>
  } else {
    const redirectURL = homeURL(authUser)
    if (redirectURL) {
      return <Navigate replace to={redirectURL} />
    } else {
      logout()
      return <Navigate replace to={loginURL()} />
    }
  }
}

export default IsPracticeGroup